import { Dropdown, FormLayout, TextInput } from 'components/common'
import {
  CommonFormType,
  FTP_PROTOCOLS,
  activeOptions,
  aggregatorFormFields,
  deleteFilesOptions,
  ftpProtocolOptions,
  getNestErrorMessage,
} from '../utils'

const {
  FTP_ACTIVE,
  FTP_HOST,
  FTP_PASSWORD,
  FTP_PATH,
  FTP_PORT,
  FTP_PROTOCOL,
  FTP_USERNAME,
  FTP_DELETE_FILES,
  FTP_FILE_GENERATION_LIMIT: FILE_GENERATION_LIMIT,
} = aggregatorFormFields

function FtpConfigurationForm({
  register,
  errors,
  setValue,
  aggregator,
  ftpIsActive,
}: CommonFormType) {
  return (
    <>
      <h3 className="title">FTP Configuration</h3>

      <FormLayout>
        <div className="flex flex-col gap-2">
          {/* <div className="mid-md:w-1/3 mid-md:pr-4"> */}
          <div className="flex flex-col gap-2 mid-md:flex-row mid-md:gap-5">
            {/* FTP Active */}
            <Dropdown
              required
              defaultValue={aggregator?.ftp?.isEnable ?? false}
              setValue={setValue}
              options={activeOptions}
              label={FTP_ACTIVE.label}
              name={FTP_ACTIVE.parentKey + '.' + FTP_ACTIVE.key}
              error={getNestErrorMessage(errors, FTP_ACTIVE)}
            />

            {/* FTP Delete Files */}
            <Dropdown
              required={ftpIsActive}
              defaultValue={aggregator?.ftp?.deleteFiles ?? true}
              setValue={setValue}
              options={deleteFilesOptions}
              label={FTP_DELETE_FILES.label}
              name={FTP_DELETE_FILES.parentKey + '.' + FTP_DELETE_FILES.key}
              error={getNestErrorMessage(errors, FTP_DELETE_FILES)}
            />

            {/* FTP HOST */}
            <TextInput
              required={ftpIsActive}
              register={register}
              label={FILE_GENERATION_LIMIT.label}
              name={
                FILE_GENERATION_LIMIT.parentKey +
                '.' +
                FILE_GENERATION_LIMIT.key
              }
              error={getNestErrorMessage(errors, FILE_GENERATION_LIMIT)}
            />
          </div>

          <div className="flex flex-col gap-2 mid-md:flex-row mid-md:gap-5">
            {/* FTP PROTOCOL */}
            <Dropdown
              required={ftpIsActive}
              setValue={setValue}
              options={ftpProtocolOptions}
              defaultValue={aggregator?.ftp?.protocol || FTP_PROTOCOLS.FTP}
              label={FTP_PROTOCOL.label}
              name={FTP_PROTOCOL.parentKey + '.' + FTP_PROTOCOL.key}
              error={getNestErrorMessage(errors, FTP_PROTOCOL)}
            />

            {/* FTP HOST */}
            <TextInput
              required={ftpIsActive}
              register={register}
              label={FTP_HOST.label}
              name={FTP_HOST.parentKey + '.' + FTP_HOST.key}
              error={getNestErrorMessage(errors, FTP_HOST)}
            />

            {/* FTP PORT */}
            <TextInput
              required={ftpIsActive}
              register={register}
              label={FTP_PORT.label}
              name={FTP_PORT.parentKey + '.' + FTP_PORT.key}
              error={getNestErrorMessage(errors, FTP_PORT)}
            />
          </div>

          <div className="flex flex-col gap-2 mid-md:flex-row mid-md:gap-5">
            {/* User name */}
            <TextInput
              required={ftpIsActive}
              register={register}
              label={FTP_USERNAME.label}
              name={FTP_USERNAME.parentKey + '.' + FTP_USERNAME.key}
              error={getNestErrorMessage(errors, FTP_USERNAME)}
            />

            {/* Password */}
            <TextInput
              type="password"
              required={ftpIsActive}
              register={register}
              label={FTP_PASSWORD.label}
              name={FTP_PASSWORD.parentKey + '.' + FTP_PASSWORD.key}
              error={getNestErrorMessage(errors, FTP_PASSWORD)}
            />
          </div>

          {/* PATH */}
          <TextInput
            required={ftpIsActive}
            register={register}
            label={FTP_PATH.label}
            name={FTP_PATH.parentKey + '.' + FTP_PATH.key}
            error={getNestErrorMessage(errors, FTP_PATH)}
          />
        </div>
      </FormLayout>
    </>
  )
}

export default FtpConfigurationForm
